/* eslint-disable react/prop-types */
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Eye, Trash2, PenLine, Edit } from "lucide-react";
import hasPermission from "@/hooks/hasPermission";

export function CustomerTypeTable({
  tableData,
  setTableData,
  deleteType,
  setEditCustomerType,
  reset,
}) {
  return (
    <div className=" w-full">
      <Table className="w-full">
        <TableHeader>
          <TableRow>
            {/* <TableHead className="w-[140px]">ID</TableHead> */}
            <TableHead>Name</TableHead>
            <TableHead>Status</TableHead>
            {/* <TableHead>Status</TableHead> */}
            <TableHead className="text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {tableData?.length == 0 && (
            <TableRow>
              <TableCell colSpan="8" className="text-center">
                No discount found
              </TableCell>
            </TableRow>
          )}
          {tableData?.length > 0 &&
            tableData?.map((data) => (
              <TableRow key={data?.id}>
                <TableCell>{data?.name}</TableCell>
                <TableCell>{data?.status}</TableCell>
                <TableCell className=" flex gap-2 justify-end">
                  {hasPermission("back_office.settings.customer_type_update") && (
                    <button
                      onClick={() => {
                        setEditCustomerType({
                          id: data?.id,
                          name: data?.name,
                          status: data?.status,
                        });
                        reset({
                          name: data?.name,
                          status: data?.status == "active" ? true : false,
                        });
                      }}
                      className=" text-color7"
                    >
                      <Edit size={18} />
                    </button>
                  )}
                  {hasPermission("back_office.settings.customer_type_delete") && (
                    <button
                      onClick={() => deleteType(data?.id)}
                      className=" text-color8"
                    >
                      <Trash2 size={18} />
                    </button>
                  )}
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </div>
  );
}

